import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from "rxjs";
import { CurrentBenchmark } from "src/app/models/current-benchmark.model";
import { LttrStrategyService } from "src/app/services/lttr-strategy.service";
import { FactorStrategy } from 'src/app/models/factor-strategy.model';

@Component({
  selector: 'app-portfolio-models',
  templateUrl: './portfolio-models.component.html',
  styleUrls: ['./portfolio-models.component.scss']
})
export class PortfolioModelsComponent implements OnInit, OnDestroy {

  styleBoxData: any;

  targetStrategy1: FactorStrategy;
  targetStrategy1Subscription: Subscription;
  targetStrategy2: FactorStrategy;
  targetStrategy2Subscription: Subscription;
  targetStrategy3: FactorStrategy;
  targetStrategy3Subscription: Subscription;
  targetStrategyBenchmark: CurrentBenchmark;
  targetStrategyBenchmarkSubscription: Subscription;
  targetStrategiesLoaded: boolean = false;

  investmentZone: string;
  currency: string;
  marketPositions: string;
  inceptionDate: Date;
  lastDate: Date;
  assetClass: string;

  panelOpenState = false;
  selectBlock: string = '';

  constructor(private lttrStrategyService: LttrStrategyService) {}

  ngOnInit(): void {
    this.lttrStrategyService.loadTargetStrategies();
    this.subscribeToTargetStrategies();
  }

  ngOnDestroy() {
    if(this.targetStrategy1Subscription!=undefined) { this.targetStrategy1Subscription.unsubscribe(); }
    if(this.targetStrategy2Subscription!=undefined) { this.targetStrategy2Subscription.unsubscribe(); }
    if(this.targetStrategy3Subscription!=undefined) { this.targetStrategy3Subscription.unsubscribe(); }
    if(this.targetStrategyBenchmarkSubscription!=undefined) { this.targetStrategyBenchmarkSubscription.unsubscribe(); }
  }

  subscribeToTargetStrategies() {
    this.targetStrategy1Subscription = this.lttrStrategyService.targetStrategy1Subject.subscribe(
      (strategy: FactorStrategy) => {
        this.targetStrategy1 = strategy;
        this.targetStrategiesLoaded = (this.targetStrategy1!=undefined) && (this.targetStrategy2!=undefined) && (this.targetStrategy3!=undefined);
        if (this.targetStrategiesLoaded) {this.computeStyleBoxData();}
        this.initializeVariables(strategy);
      }
    );
    this.targetStrategy2Subscription = this.lttrStrategyService.targetStrategy2Subject.subscribe(
      (strategy: FactorStrategy) => {
        this.targetStrategy2 = strategy;
        this.targetStrategiesLoaded = (this.targetStrategy1!=undefined) && (this.targetStrategy2!=undefined) && (this.targetStrategy3!=undefined);
        if (this.targetStrategiesLoaded) {this.computeStyleBoxData();}
        this.initializeVariables(strategy);
      }
    );
    this.targetStrategy3Subscription = this.lttrStrategyService.targetStrategy3Subject.subscribe(
      (strategy: FactorStrategy) => {
        this.targetStrategy3 = strategy;
        this.targetStrategiesLoaded = (this.targetStrategy1!=undefined) && (this.targetStrategy2!=undefined) && (this.targetStrategy3!=undefined);
        if (this.targetStrategiesLoaded) {this.computeStyleBoxData();}
        this.initializeVariables(strategy);
      }
    );
    this.targetStrategyBenchmarkSubscription = this.lttrStrategyService.targetStrategyBenchmarkSubject.subscribe(
      (benchmark: CurrentBenchmark) => {
        this.targetStrategyBenchmark = benchmark;
      }
    );

    this.lttrStrategyService.emitTargetStrategy1();
    this.lttrStrategyService.emitTargetStrategy2();
    this.lttrStrategyService.emitTargetStrategy3();
    this.lttrStrategyService.emitTargetStrategyBenchmark();
  }

  computeRankings(strategy: FactorStrategy) {
    return {
      factor_deconcentration: {
        nb_analysis: strategy.factorAnalysis.rankings.factor_deconcentration_quality.nb_analysis_factor_deconcentration_quality,
        rank: strategy.factorAnalysis.rankings.factor_deconcentration_quality.rank_factor_deconcentration_quality,
        rating: strategy.factorAnalysis.diversification.factor_deconcentration_quality_rating
      },
      factor_diversification: {
        nb_analysis: strategy.factorAnalysis.rankings.factor_diversification_quality.nb_analysis_factor_diversification_quality,
        rank: strategy.factorAnalysis.rankings.factor_diversification_quality.rank_factor_diversification_quality,
        rating: strategy.factorAnalysis.diversification.factor_diversification_quality_rating
      }
    }
  }

  computeStyleBoxData() {
    this.styleBoxData = {
      default1:  this.computeRankings(this.targetStrategy1),
      default2:  this.computeRankings(this.targetStrategy2),
      default3: this.computeRankings(this.targetStrategy3),
    }
  }

  initializeVariables(data: any) {
    if (data!=undefined) {
      this.inceptionDate = new Date(data.inception_date);
      this.lastDate = new Date(data.last_date);
    }
  }
}
